module.exports = __webpack_public_path__ + "static/img/scan1.e351c91.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/scan1.jpeg
// module id = 7uyc
// module chunks = 0